module.exports = __webpack_public_path__ + "img/10.710a24ae.jpg";